import { useEffect, useMemo, useState } from "react";
import styles from "./experts-comment.module.scss";
import { setExpertsCommentHeight } from "../../../redux/quiz-slice";
import { useDispatch } from "react-redux";
import { Animate } from "../../animation/animation";
import cn from 'classnames';

export interface IExpertsCommentProps {
  height: number;
  text: string;
  maxQuestionCommentLength: number;
  active: boolean;
  shift?: boolean;
}

export function ExpertsComment({ text, maxQuestionCommentLength, height, active, shift }: IExpertsCommentProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    const currentTextLength = text.length;
    const maxLength = Math.max(maxQuestionCommentLength, currentTextLength);
    const paddingSize = 15;
    const height = Math.ceil(maxLength/getMaxSymbolsPerLine()) * getTextSize() + (paddingSize * 2);
    dispatch(setExpertsCommentHeight(height));
  }, [text, maxQuestionCommentLength, dispatch]);
  return (<Animate animation={'fade'} when={active} delay={400} transitionProperty={"opacity"}>
    <div className={cn(styles.default, { [styles.shift]: shift })} style={{ height: height + "px"}}>
      <p className={styles.text}>{text}</p>
    </div>
  </Animate>)
}

function getTextSize() {
  let textSize = 20;
  if (window.innerWidth > 410) textSize = 24;
  if (window.innerWidth > 768) textSize = 40;
  return textSize
}

function getMaxSymbolsPerLine() {
  let size = 40;
  if (window.innerWidth > 768) size = 38;
  return size;
}